import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

export const SimpleTag: React.FC<React.PropsWithChildren> = ({ children }) => {
	return <div className={css(styleSheet.simpleTag)}>{children}</div>;
};
